import { createEvent, sample } from 'effector'
import { model as router } from '~/core/router'

export const seeAllLiveEventsClick = createEvent()
sample({
  clock: seeAllLiveEventsClick,
  fn: () => '/modules/events?module=Home&routeName=Events',
  target: router.navigatePush,
})

export const seeAllPartnerProgramClick = createEvent()
sample({
  clock: seeAllPartnerProgramClick,
  fn: () => '/modules/partner',
  target: router.navigatePush,
})
